'use client'

import * as React from 'react'
import { Info } from 'lucide-react'

// Minimal app-wide toast for surfaces without an RToastProvider (the save
// heart renders on search cards, the map, the detail page — none wrapped in
// the roostr toast context). Fire with `emitGlobalToast(message)` from
// anywhere; a single instance mounted in the root layout renders it.
const EVENT = 'roostr:global-toast'

export function emitGlobalToast(message: string) {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent<string>(EVENT, { detail: message }))
}

export function GlobalToast() {
  const [message, setMessage] = React.useState<string | null>(null)
  const timer = React.useRef<ReturnType<typeof setTimeout> | null>(null)

  React.useEffect(() => {
    const onToast = (e: Event) => {
      const detail = (e as CustomEvent<string>).detail
      if (!detail) return
      setMessage(detail)
      if (timer.current) clearTimeout(timer.current)
      timer.current = setTimeout(() => setMessage(null), 3200)
    }
    window.addEventListener(EVENT, onToast)
    return () => {
      window.removeEventListener(EVENT, onToast)
      if (timer.current) clearTimeout(timer.current)
    }
  }, [])

  if (!message) return null

  return (
    <div className="pointer-events-none fixed inset-x-0 bottom-6 z-[100] flex justify-center px-4">
      <div
        role="status"
        className="pointer-events-auto flex max-w-[92vw] items-center gap-2.5 rounded-full border border-outline-variant bg-surface px-4 py-2.5 shadow-e3 animate-pop-in"
      >
        <Info size={16} className="shrink-0 text-primary" />
        <span className="text-[13px] font-medium text-ink">{message}</span>
      </div>
    </div>
  )
}
